import React from 'react';
import Typewriter from 'components/Typewriter';
import Scrollchor from 'react-scrollchor';

class Hero extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      

      <div className="hero-container">
        <Typewriter className="hero-title" text="tkdev.online" />

        <div className="hero-description">
          Full-stack developer obsessed with building elegant solutions to hard problems.<br />Some hobby {' '}
          <Scrollchor to="#projects">projects</Scrollchor> below!
        </div>
      </div>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js